import { IconButton, Modal, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PersonIconButton = styled(IconButton)(({ theme }) => ({
  margin: 0,
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  // Mobile styles (xs and up)
  width: "90%",
  maxWidth: "500px",
  minHeight: "min(85vh, 640px)",
  maxHeight: "calc(100vh - 100px)",
  margin: "auto",
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "white",
  borderRadius: "10px",
  zIndex: 10,
  display: "flex",
  overflow: "hidden",

  // Desktop and up (md)
  [theme.breakpoints.up('md')]: {
    maxWidth: "1000px",
    borderRadius: "15px",
  },

  ".inner-root": {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column"
  }
}));

export const TrialContainer = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  // padding: "2px",
  position: "relative",
  display: "flex",
  alignItems: "stretch",
  justifyContent: "center",
  // Content is size-bounded (image at maxHeight: 100%, form-root at
  // height: 100%). Hide any sub-pixel overflow so the parent
  // .inner-root's overflowY: auto doesn't spawn a scrollbar.
  overflow: "hidden",

  ".trial-graphic": {
    flex: "55 1 0",
    minWidth: 0,
    alignSelf: "center",
    height: "auto",
    maxHeight: "100%",
    objectFit: "contain",
    objectPosition: "center",
    display: "block",
    borderRadius: "10px",
    [theme.breakpoints.down('md')]: {
      display: "none",
    },
  },

  ".form-root": {
    margin: "auto",
    flex: "1 1 45%",
    minWidth: 0,
    width: "45%",

    "&.trial": {
      position: "relative",
      height: "100%",
      width: "100%",
      boxSizing: "border-box",
      paddingRight: "14px",

      justifyContent: "center",
      flexDirection: "column",

      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
      },
    },
  },
  ".main-title": {
    paddingTop:"10px",
    fontSize: "25px",
    lineHeight: "115%",
    marginBottom: "5px",
  },
  ".bold-paraHeading": {
    paddingTop:"10px",
    fontSize: "13px",
    fontWeight: "Bold",
  },
  ".para-sub": {
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: '1.4',
    color: '#8C8C8C',
  },
  ".close-btn": {
    position: "absolute",
    right: "20px",
    top: "20px",
    backgroundColor: "transparent",
    color: "#8C8C8C",
    padding: "4px",
    [theme.breakpoints.down("sm")]: { padding: "10px", right: "6px", top: "6px" },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#5C5C5C",
    },
  },
}));
